import { render } from "./End1.vue?vue&type=template&id=2cfcdfe6"
import script from "./End1.vue?vue&type=script&lang=js"
export * from "./End1.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/digiworks/SecoursCatholique/Secours-Catholique_Mots_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__